export const TRUST_LOGIN_HINT_KEY = "privacy:trust-login-hint";

export const setTrustLoginHint = (loggedIn: boolean) => {
  localStorage.setItem(TRUST_LOGIN_HINT_KEY, JSON.stringify(loggedIn));
};

export const getTrustLoginHint = (): boolean => {
  try {
    return JSON.parse(localStorage.getItem(TRUST_LOGIN_HINT_KEY) || "false") === true;
  } catch {
    return false;
  }
};
